var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "md", type: "light" } },
        [
          _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
          _vm._v(" "),
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _c("span", [_vm._v("Administración de Pedidos")])
          ]),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { "is-nav": "", id: "nav_collapse" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-form",
                    [
                      _c("b-form-input", {
                        staticClass: "mr-sm-2",
                        attrs: {
                          size: "sm",
                          type: "text",
                          placeholder: "Buscar"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "my-2 my-sm-0",
                          attrs: { size: "sm", type: "submit" }
                        },
                        [_vm._v("Buscar")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    { staticClass: "ml-2", attrs: { right: "" } },
                    [
                      _c("template", { slot: "button-content" }, [
                        _c("em", [_vm._v("Admin")])
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "" } }, [
                        _vm._v("Perfil")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#/logout" } }, [
                        _vm._v("Cerrar sesión")
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "b-list-group",
                [
                  _c("b-list-group-item", [
                    _c("a", { attrs: { href: "/clients-by-brands" } }, [
                      _vm._v("Clientes por marcas")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-list-group-item", [
                    _c("a", { attrs: { href: "/clients-by-offices" } }, [
                      _vm._v("Clientes por oficinas")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-list-group-item", { attrs: { active: "" } }, [
                    _c("a", { attrs: { href: "/" } }, [_vm._v("Marcas")])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "h2",
                        [
                          _vm._v("\n              Add Client\n              "),
                          _c("b-link", { attrs: { href: "/" } }, [
                            _vm._v("(Client List)")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        { on: { submit: _vm.onSubmit } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "First Name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "firstName", state: _vm.state },
                                model: {
                                  value: _vm.client.firstName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "firstName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.firstName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Last Name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "lastName", state: _vm.state },
                                model: {
                                  value: _vm.client.lastName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "lastName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.lastName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "DNI"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "dni", state: _vm.state },
                                model: {
                                  value: _vm.client.dni,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "dni",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.dni"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Phone"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "phone", state: _vm.state },
                                model: {
                                  value: _vm.client.phone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "phone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.phone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Email"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "email", state: _vm.state },
                                model: {
                                  value: _vm.client.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "store"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "publisher", state: _vm.state },
                                model: {
                                  value: _vm.client.store,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "store",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.store"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Brand"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "brand", state: _vm.state },
                                model: {
                                  value: _vm.client.brand,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "brand",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.brand"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Model Car"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "model_car", state: _vm.state },
                                model: {
                                  value: _vm.client.model_car,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "model_car",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.model_car"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "code"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "code", state: _vm.state },
                                model: {
                                  value: _vm.client.code,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "code",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.code"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { attrs: { type: "submit", variant: "primary" } },
                            [_vm._v("Save")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06351c97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06351c97","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateClient.vue
// module id = null
// module chunks = 